import ImageLoader from '../components/ImageLoader'


export default function(){
    return (
        <div>
            <ImageLoader src={require("../images/team/bkg--team-1.jpg").default} />
        </div>
    )
}